import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { EquipmentsTypesApi } from 'app/main/settings/registers/equipments-types/services/api/equipments-types-api.service';
import { debounceTime } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return EquipmentsTypeSelectComponent; }),
    multi: true
};
var EquipmentsTypeSelectComponent = /** @class */ (function () {
    function EquipmentsTypeSelectComponent(fuseTranslationLoaderService, equipmentsTypesApi) {
        var _this = this;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.equipmentsTypesApi = equipmentsTypesApi;
        this.required = true;
        this.disabled = false;
        this.appearance = 'legacy';
        this.selectedValue = new FormControl();
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.searchEquipmentsTypes();
        this.selectedValue.valueChanges.pipe(debounceTime(500)).subscribe(function (value) {
            if (value) {
                _this.onChange(value);
            }
        });
    }
    EquipmentsTypeSelectComponent.prototype.ngOnInit = function () {
        if (this.required) {
            this.selectedValue.setValidators(Validators.required);
        }
    };
    EquipmentsTypeSelectComponent.prototype.searchEquipmentsTypes = function () {
        var _this = this;
        var options = {
            where: { archived: false },
            orderBy: 'name_asc',
            limit: 100,
            offset: 0
        };
        this.equipmentsTypesApi
            .listEquipmentsTypes(options)
            .subscribe(function (response) {
            _this.equipmentsTypes = response.items;
            if (_this.selectedValue.value) {
                var currentEquipmentTypeIsOnList = _this.equipmentsTypes.some(function (equipmentType) {
                    return equipmentType.id === _this.selectedValue.value.id;
                });
                if (!currentEquipmentTypeIsOnList) {
                    _this.equipmentsTypes.push(_this.selectedValue.value);
                }
            }
        });
    };
    EquipmentsTypeSelectComponent.prototype.compareEquipmentType = function (someEquipmentType, anotherEquipmentType) {
        return (someEquipmentType && anotherEquipmentType)
            && (someEquipmentType.id === anotherEquipmentType.id);
    };
    EquipmentsTypeSelectComponent.prototype.writeValue = function (equipmentType) {
        this.selectedValue.setValue(equipmentType);
    };
    EquipmentsTypeSelectComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    EquipmentsTypeSelectComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    return EquipmentsTypeSelectComponent;
}());
export { EquipmentsTypeSelectComponent };
